import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tw-w-full" };
import { ref, computed } from 'vue';
import { usePopupStore } from '@/stores/popup';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SideBarProviders',
    props: {
        games: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ['viewGames'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const searchQuery = ref('');
        const gameUrl = ref(null);
        const scrollContainer = ref(null);
        // Computed property to filter games based on searchQuery
        const filteredGames = computed(() => {
            return props.games.filter(game => game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        });
        const handleGameClick = (game) => {
            if (!localStorage.getItem('user')) {
                usePopupStore().showPopup('login');
                return;
            }
            const url = `https://azurecoinz.com/game/${game.name}?api_exit=/`;
            window.innerWidth < 768 ? window.open(url, '_blank') : (gameUrl.value = url);
        };
        const closeGame = () => (gameUrl.value = null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
                _createStaticVNode("<div class=\"row\"><div class=\"col-12\"><img src=\"/assets/images/providers/allproviders1.png\" alt=\"\"></div><div class=\"col-12 tw-pt-2\"><img src=\"/assets/images/providers/allproviders2.png\" alt=\"\"></div><div class=\"col-12 tw-pt-2\"><img src=\"/assets/images/providers/allproviders3.png\" alt=\"\"></div></div>", 1)
            ])));
        };
    }
});
